import Card from "@mui/material/Card"
import break_defs from "../../configs/breaks.json"

const gradient_legend = (au_render_prop) => {
  const break_data =
    au_render_prop === "distance_to_nearest_facility"
      ? break_defs.linear_breaks
      : break_defs.exp_breaks

  const breaks = []
  for (const [colour, [lower, upper]] of Object.entries(break_data)) {
    const label =
      upper === Infinity
        ? `> ${lower.toLocaleString()}`
        : `${lower.toLocaleString()} - ${upper.toLocaleString()}`
    breaks.push([colour, label])
  }

  return (
    <Card
      style={{
        position: "absolute",
        bottom: "30px",
        right: "160px",
        zIndex: 600,
      }}
    >
      <div
        style={{
          float: "left",
          textAlign: "center",
        }}
      >
        {breaks.reverse().map(([colour, label]) => (
          <div key={colour} style={{ background: colour, padding: 5 }}>
            {label}
          </div>
        ))}
      </div>
    </Card>
  )
}

export default function MapLegend({ au_geo_json, visualisation_settings }) {
  if (
    !au_geo_json ||
    !visualisation_settings.au_render_prop ||
    visualisation_settings.au_render_prop === "allocated_to_group" ||
    visualisation_settings.au_render_prop === "catchment_group"
  ) {
    return null
  }

  return gradient_legend(visualisation_settings.au_render_prop)
}
